import { lazy, Suspense } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { ViewportCenterCircle } from "@newComponents/common/ViewportCenterCircle";
import { ContactProvider } from "@newComponents/contact/context/contact.context";

const ContactPage = lazy(() => import("@newPages/contact/ContactPage"));

export function ContactRoute() {
  const match = useRouteMatch();

  return (
    <Suspense fallback={<ViewportCenterCircle />}>
      <Switch>
        <Route
          exact
          path={match.path}
          render={() => (
            <ContactProvider>
              <ContactPage />
            </ContactProvider>
          )}
        />
        <Route path={match.path} exact render={() => <Redirect to={match.path} />} />
      </Switch>
    </Suspense>
  );
}
